export const SET_TAB = 'SET_TAB';
export const SET_TAB_TRIGGER = 'SET_TAB_TRIGGER';
export const SET_CRITERIAS = 'SET_CRITERIA';
export const SET_CRITERIAS_ASYNC = 'SET_CRITERIAS_ASYNC';
export const GET_PROFILE_STORIES = 'GET_PROFILE_STORIES';
export const GET_PROFILE_STORIES_ASYNC = `${GET_PROFILE_STORIES}_ASYNC`;
export const SET_HOME_LOADING = 'SET_HOME_LOADING';
